import { combineReducers } from "redux";

import { pdfDownloadsReducer } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/download-pdf/store/reducer";
import { leadGeneratorReducer } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/lead-generator/store";

import { chatReducer } from "./chat";
import type { AIAgentState } from "./types";

const aiAgentReducer = combineReducers<AIAgentState>({
    leadGenerator: leadGeneratorReducer,
    chat: chatReducer,
    pdfDownloads: pdfDownloadsReducer,
});

export default aiAgentReducer;
